import React from 'react'
import { useQuery } from '@apollo/react-hooks'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import {
  message, Select, Icon, Menu, Dropdown, Button, Select as AntdSelect,
} from 'antd'
import {
  SmallText, Div, Button as KonsysButton, Loading,
} from 'konsys-ui'
import history from '../../history'
import { WAREHOUSES, CATEGORIES, BRANDS } from '../../constants/graph/query'
import { theme } from '../../styles/_variables'
import { status, statusText } from '../../pages/inventory-page/constants'
import { P } from '../../pages/inventory-page/styled'
import PERMISSION from '../../constants/permissions'

const { color } = theme

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const CellText = props => (
  <P font='sarabun' padding='3px' {...props}>{props.children}</P>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange, value }) => (
  <input placeholder='ค้นหา' onChange={(e) => {
    handleChange(e.target.value)
  }} value={value} />
)

export const CategorySelector = ({ onChange }) => {
  const { loading: cateLoading, data: cateData, error: cateError } = useQuery(CATEGORIES)
  if (cateLoading || _.isEmpty(cateData)) return <Loading />
  const CATEGORY = [{ value: '', text: 'ทั้งหมด' }].concat(cateData.getCategoryList.data.map(v => ({ text: v, value: v })))
  return (<DropdownSelector
    brand={true}
    key='filter'
    data={CATEGORY}
    handleChange={e => onChange(e)}
    filter={true}
    statusAttr='ทั้งหมด'
  />)
}

export const BrandSelector = ({ onChange }) => {
  const { loading: brandsLoading, data: brandsData, error: brandsError } = useQuery(BRANDS)
  if (brandsLoading || _.isEmpty(brandsData)) return <Loading />
  const BRAND = [{ value: '', text: 'ทั้งหมด' }].concat(brandsData.getBrandList.data.map(v => ({ text: v, value: v })))
  return (<DropdownSelector
    brand={true}
    key='filter'
    data={BRAND}
    handleChange={e => onChange(e)}
    filter={true}
    statusAttr='ทั้งหมด'
  />)
}

const menu = id => (
  <Div>
    <Menu>
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_INVENTORY)}>
        <Link target="_blank" to={`/inventory/view/${id}`}>
          ดูรายละเอียด
        </Link>
      </Menu.Item>
      <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_INVENTORY)}>
        <Link target="_blank" to={`/inventory/edit/${id}`}>
          แก้ไข
        </Link>
      </Menu.Item>
      <Menu.Item key='transfer' disabled={!_.includes(window.perms, PERMISSION.UPDATE_INVENTORY)}>
        <Link target="_blank" to={`/inventory/transfer/${id}`}>
          โอนย้ายสต๊อก
        </Link>
      </Menu.Item>
      <Menu.Item key='adjust' disabled={!_.includes(window.perms, PERMISSION.UPDATE_INVENTORY)}>
        <Link target="_blank" to={`/inventory/adjust/${id}`}>
          แก้ไขจำนวนสต๊อก
        </Link>
      </Menu.Item>
      <Menu.Item key='history' disabled={!_.includes(window.perms, PERMISSION.UPDATE_INVENTORY)}>
        <Link target="_blank" to={`/inventory/history/${id}`}>
          ประวัติ
        </Link>
      </Menu.Item>
    </Menu>
  </Div>
)

export const ActionSelector = ({ props: { original: { id } } }) => (
  <Dropdown overlay={menu(id)} trigger='click'>
    <Button>
      ดูรายละเอียด <Icon type="down" />
    </Button>
  </Dropdown>
)

export const WarehouseSelector = ({ onChange }) => {
  const {
    data, loading, error, fetchMore, refetch,
  } = useQuery(WAREHOUSES, { variables: { limit: 99 } })
  if (loading || _.isEmpty(data)) return <Loading center='true' />
  return (
    <Select
      style={{ width: 280 }}
      defaultValue="ทั้งหมด"
      onSelect={e => onChange(e)}
    >
      <Select.Option key='all' value={undefined}>ทั้งหมด</Select.Option>
      {
        data.warehouseList.data.list.map(v => <Select.Option key={v.id} value={v.id}>{v.warehouseName}</Select.Option>)
      }
    </Select>
  )
}

export const DropdownSelector = ({
  data, handleChange, brand,
}) => {
  const width = brand ? '130px' : '100px'
  return (
    <AntdSelect
      defaultValue='ทั้งหมด'
      dropdown
      maxHeight='none'
      style={{ width }}
      onChange={e => (e === 'ALL' ? handleChange('') : handleChange(e))}
    >
      {
        data.map(v => <AntdSelect.Option key={v.value} value={v.value}>{v.text}</AntdSelect.Option>)
      }
    </AntdSelect>
  )
}

export const ActionBar = ({
  loading, isAddMode, isViewMode, doAction, mutationVariables, props, disabled,
}) => (
    <Div
      position='fixed'
      height='72px'
      bottom='0'
      left='0'
      right='0'
      style={{ background: `${color.primaryColor}33` }}
      display='flex'
      justifyContent='flex-end'
      alignItems='center'
      padding='0 32px 0 0'
    >
      <KonsysButton
        loading={loading}
        disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_INVENtory)) || disabled}
        text={isAddMode ? 'สร้างใหม่' : isViewMode ? 'แก้ไข' : 'บันทึก'}
        icon={isAddMode ? 'fas fa-plus' : isViewMode ? 'fas fa-edit' : 'fas fa-save'}
        inverse
        onClick={() => {
          if (isViewMode) history.push(`/inventory/edit/${props.match.params.id}`)
          else {
            doAction({
              variables: isAddMode ? { ...mutationVariables } : { id: parseInt(props.match.params.id, 10), ...mutationVariables },
            }).then(({ data }) => {
              const resp = isAddMode ? data.CreateGarage : data.UpdateGarage
              if (resp.success) {
                message.success(resp.message)
                if (isAddMode) history.push('/inventory')
                // else {
                //   refetch()
                //   history.push(`/mechanic/view/${props.match.params.id}`)
                // }
              } else message.error(resp.message)
            })
          }
        }}
      />
    </Div>
)
